import { ReactElement } from 'react';

import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import {
   useVisitAndAppointmentStatusFilterSearchParamHandler,
   useVisitAndAppointmentStatusTriggerLabelExtractor,
} from './VisitAndAppointmentStatusField.hooks';
import { StyledVisitAndAppointmentStatusField } from './VisitAndAppointmentStatusField.styled';
import { visitAndAppointmentStatusToIdMap } from './VisitAndAppointmentStatusField.utils';

type VisitAndAppointmentStatusFieldFormBeanPart = {
   visitAndAppointmentStatuses: VisitAndAppointmentStatus[];
};

const items = Object.keys(visitAndAppointmentStatusToIdMap) as VisitAndAppointmentStatus[];

type VisitAndAppointmentStatusFieldProps = {
   register: BindingCreator<VisitAndAppointmentStatusFieldFormBeanPart, 'visitAndAppointmentStatuses'>;
   currentFilter: VisitAndAppointmentStatus[];
};

export const VisitAndAppointmentStatusField = (props: VisitAndAppointmentStatusFieldProps): ReactElement => {
   const handleHide = useVisitAndAppointmentStatusFilterSearchParamHandler(props.currentFilter);
   return (
      <StyledVisitAndAppointmentStatusField>
         <Multiselect<VisitAndAppointmentStatus>
            testId={'visitAndAppointmentStatus'}
            triggerLabelExtractor={useVisitAndAppointmentStatusTriggerLabelExtractor()}
            placeholder={appointmentsTranslationKeys.visitAndAppointmentStatusFilter.selectStatuses}
            controller={props.register('visitAndAppointmentStatuses')}
            onHide={handleHide}
         >
            <>
               <Multiselect.SelectAll<VisitAndAppointmentStatus>
                  testId={'selectAllStatuses'}
                  items={items}
                  selectAllLabel={appointmentsTranslationKeys.visitAndAppointmentStatusFilter.selectAll}
               />
               <Multiselect.List items={items}>
                  {(item) => (
                     <Multiselect.Item item={item} testId={item} label={appointmentsTranslationKeys.statusCode[item]} />
                  )}
               </Multiselect.List>
            </>
         </Multiselect>
      </StyledVisitAndAppointmentStatusField>
   );
};
